import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { ProductCategory } from 'src/app/models/virtual-store/product-category.model';
import { CommonService } from 'src/app/services/common.service';
import { Subject, Subscription } from 'rxjs';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { CheckableItem } from 'src/app/core/models/checkable-item.model';
import { VirtualStoreService } from 'src/app/services/virtual-store.service';
import { Account } from 'src/app/models/account.model';
import { DetailedOrderItem } from 'src/app/models/virtual-store/detailed-order-item.model';
import { OrderItemService } from 'src/app/services/order-item.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { MasterTableService } from 'src/app/services/master-table.service';
import { CreditLineFNB } from 'src/app/models/account/credit-line-fnb.model';
import { Basic } from 'src/app/core/models/basic.model';
import { MasterService } from 'src/app/services/master.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { takeUntil } from 'rxjs/operators';
import { AppConstant } from 'src/app/constants/app.constant';
import { EnvironmentService } from 'src/app/core/services/environment.service';

@Component({
  selector: 'app-virtual-store-header',
  templateUrl: './virtual-store-header.component.html',
  styleUrls: ['./virtual-store-header.component.scss']
})
export class VirtualStoreHeaderComponent implements OnInit, OnDestroy {
  //@ViewChild(MatMenuTriggerFor, { static: true }) triggerBtn: MatMenuTriggerFor;
  @ViewChild(MatMenuTrigger, { static: false }) triggerBtn: MatMenuTrigger;
  //@ViewChild("myPopover", { static: false })  popover: Popover;
  @Input() isClient: boolean;
  catalogUrl = '/tienda'
  shoppingCartUrl = '/ofivirtual/tienda/carrito'
  categoryList: CheckableItem<ProductCategory>[] = [];
  categoryMovilList: ProductCategory[] = [];
  orderItemList: DetailedOrderItem[] = [];
  selectedAccount: Account;
  /*Suscripción a observable de pedido actualizado */
  orderUpdatedSubscription: Subscription;
  /*Suscripción a observable de cuenta seleccionada */
  accountSelectedSubscription: Subscription;
  /**Suscripción a observable de eventos de router */
  routerEventSubscription: Subscription;
  showShoppingCart = false;
  cantOrderItems = 0;

  flag: boolean = false;
  creditLineFNB: CreditLineFNB = new CreditLineFNB();
  sortModeList: Basic<string>[] = [];
  selectedSortMode: string;
  itemCategorySelected = new CheckableItem<ProductCategory>(new ProductCategory());
  itemCategoryMovilSelected: any = {};
  accountDataFetchedSubscription: Subscription;
  unsubscribe$ = new Subject();
  itemsOrder: DetailedOrderItem[] = [];
  isUrlHogar: Boolean;
  routerId: number;
  routerPathDefault: any[] = ['/ofivirtual/tienda', '/stdln/tienda', '/stdln/tienda?isHogar=true'];
  filterIsActivate: boolean = true;

  constructor(
    private commonService: CommonService,
    private virtualStoreService: VirtualStoreService,
    private router: Router,
    private orderItemService: OrderItemService,
    private activatedRoute: ActivatedRoute,
    private masterTableService: MasterTableService,
    private masterService: MasterService,
    private authService: AuthService,
    private environmentService: EnvironmentService
  ) {
    this.creditLineFNB = this.authService.getCreditLineFNB();
    this.orderUpdatedSubscription = this.virtualStoreService.orderUpdatedAnnounced
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(orderItemList => {
        this.orderItemList = orderItemList;
        this.showShoppingCart = this.orderItemList.length > 0;
        //this.cantOrderItems = this.orderItemList.reduce((sum: number, b: DetailedOrderItem) => b.count, 0);
        var count = 0;
        this.orderItemList.forEach(element => {
          count += element.count;
        });
        this.cantOrderItems = count;
      })
    this.accountSelectedSubscription = this.commonService.accountSelectedAnnounced
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(account => {
        this.selectedAccount = account;
        this.getOrderItems();
      });

    this.accountDataFetchedSubscription = this.commonService.accountDataFetchedAnnounced
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(accountData => {
        this.creditLineFNB = this.authService.getCreditLineFNB();
        this.listCategories();
      });

    if (this.routerPathDefault.includes(this.router.url)) {
      this.filterIsActivate = true;
    } else {
      this.filterIsActivate = false;
    }

  }

  get getCountOrderItems() {
    return this.orderItemList
      .reduce((sum: number, b: DetailedOrderItem) => b.count, 0);
  }


  ngOnInit() {
    if (!this.isClient || this.creditLineFNB != null) {
      this.listCategories();

      this.activatedRoute.queryParams.subscribe(params => {
        this.isUrlHogar = Boolean(params['isHogar']);
      });
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this.routerPathDefault.includes(event.url)) {
          this.filterIsActivate = true;
        }
        else {
          this.filterIsActivate = false;
        }
      }
    });
  }

  async getOrderItems() {
    this.listOrderItems(false);

    /*const minutos = await this.getParameter();

    const interval = Observable.interval(minutos*60*1000);
    interval.subscribe((x : number)=>{
      this.listOrderItems(true);
    });*/
  }

  async getParameter() {
    let minutos = 5;
    const parameter = await this.masterTableService.GetMasterByKey('POPUP_VIS_PROD_XMIN_CARRITO').toPromise();

    if (parameter.valid) {
      minutos = Number(parameter.data.description);
    }
    return minutos;
  }

  listOrderItems(validarLocalStorage: boolean) {
    let isFnb = this.creditLineFNB.isCreditLineFNB;
    this.orderItemService.listPendingOnes(this.selectedAccount.clientCode, isFnb)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(response => {
        this.itemsOrder = response.data;
        this.virtualStoreService.announceOrderUpdated(this.itemsOrder);
        this.showShoppingCart = this.itemsOrder.length > 0;
      });

  }
  listCategories() {
    this.virtualStoreService.listCategories()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(response => {
        if (this.isClient) {
          if (this.creditLineFNB != null && !this.creditLineFNB.isCreditLineFNB) {
            response.data = response.data.filter((element) => {
              return element.codeFilter !== AppConstant.FNB;
            });
          } else {
            response.data = response.data.filter((element) => {
              return element.codeFilter === AppConstant.FNB;
            });
          }
        }

        this.categoryList = response.data.map(item => new CheckableItem(item));
        this.categoryMovilList = response.data;
        this.listFilters();
      })
  }

  listFilters(): void {
    this.masterService.listCatalogSortOptions()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        response => {
          if (response.valid) {
            this.sortModeList = response.data;
            this.selectedSortMode = this.sortModeList[0].code;
            let item = (this.isUrlHogar) ? this.categoryList[1] : this.categoryList[0];
            this.itemCategorySelected = item;
            this.itemCategoryMovilSelected = { code: item.data.code, description: item.data.description };
            this.categoryList.map(item => item.checked = false)
            item.check();

            this.notifyFilter();
          }
        }
      )
  }

  notifyFilter(): void {

    let filterList: Basic<string>[] = [];
    let itemFilter = new Basic<string>();
    itemFilter.code = this.itemCategorySelected.data.code;
    filterList.push(itemFilter);
    itemFilter = new Basic<string>();
    itemFilter.code = this.selectedSortMode;
    filterList.push(itemFilter);
    this.commonService.announceCategoryAndFilterSelected(filterList);
  }

  notifyFilterAndChangeDirection(): void {

    this.notifyFilter();
    if (!this.router.url.endsWith(this.catalogUrl)) {
      this.router.navigate(['./'], { relativeTo: this.activatedRoute });
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  categorySelected(item: CheckableItem<ProductCategory>) {
    this.categoryList.forEach(
      (categoryItem: CheckableItem<ProductCategory>) =>
        categoryItem.checked = false);

    item.check();
    this.itemCategorySelected = item;
    this.itemCategoryMovilSelected = { code: item.data.code, description: item.data.description };
    const token = this.authService.getAuthToken();
    location.href = `${this.environmentService.urlTiendaCatalogo}?categoryList=${item.data.code}&token=${token}`;
    return;
    this.notifyFilterAndChangeDirection();
  }

  categorySelectedMovil(code: any) {
    this.categoryList.forEach(
      (categoryItem: CheckableItem<ProductCategory>) =>
        categoryItem.checked = false);

    let item = this.categoryList.find(p => p.data.code == code.value);
    item.check();
    this.itemCategorySelected = item;
    this.itemCategoryMovilSelected = { code: item.data.code, description: item.data.description };
    this.notifyFilterAndChangeDirection();
  }

  closeShoppingCart() {
    localStorage.setItem('shoppingCart', "true");
    this.showShoppingCart = false;
  }

  filterChanged() {
    this.notifyFilter();
  }

  onActivarFiltro() {
    this.flag = !this.flag;
    this.commonService.announceFilterActivated(this.flag);
  }
}
